import { formatTime } from "../../../../utils"
export const config = {
    "name": "积分统计",
    "key": "integralStatistics",
    "nav": [
        {
            "name": "单位",
            "tabKey": "0",
            "request": {
                "url": "/cm-sites-mmp/integral/listTj?",
                "method": "get",
                "params": {
                    nickName:"",
                    title: "",
                    startTime: 0,
                    endTime: 0,
                    size: 10,
                    start: 1,
                    deptId:"",
                    account:"",
                    rmName: "",
                    sortfield: "integralCountTime",
                    sort: 0,
                },
                "paramsConfig": {
                    size: "size",
                    page: "start",
                    sort: {
                        field: "sortfield",
                        order: {
                            key: "sort",
                            select: { "ascend": '1', "descend": '-1' }
                        },
                    },
                },
                "resConfig": {
                    count: "count",
                    data: "data"
                },
                "defaultParams": {
                    nickName:"",
                    title: "",
                    startTime: 0,
                    endTime: 0,
                    size: 10,
                    start: 1,
                    deptId:"",
                    account:"",
                    rmName: "",
                    sortfield: "integralCountTime",
                    sort: 0,
                },
            },
            "renderSearch": {
                "searchConfig": [
                    [
                        {
                            "style": {
                                "float": "left"
                            },
                            "component": {
                                "name": "sta_Input",
                                "config": {
                                    style: {
                                        width: 154
                                    }
                                }
                            },
                            "placeholder": "请输入用户昵称",
                            "disabled": false,
                            "id": "sta_name",
                            "size": "default",
                            "labelCode": "nickName",
                            "labelName": "请输入用户昵称",
                            "defaultValue": "",
                            "regStr": "",
                            "regMsg": ""
                        },
                        {
                            "style": {
                                "float": "left"
                            },
                            "component": {
                                "name": "sta_Input",
                                "config": {
                                    style: {
                                        width: 154
                                    }
                                }
                            },
                            "placeholder": "请输入手机号",
                            "disabled": false,
                            "id": "sta_name",
                            "size": "default",
                            "labelCode": "account",
                            "labelName": "请输入融手机号",
                            "defaultValue": "",
                            "regStr": "",
                            "regMsg": ""
                        },

                        {
                            "style": {
                                "float": "left"
                            },
                            "component": {
                                "name": "sta_Cascader",
                                "config": {
                                    style: {
                                        width: 224
                                    },
                                    searchPlaceholder: '请选择所属部门',
                                    treeId: "0",
                                    deleteRootNode: true,
                                    defaultValue: "0",
                                    clickCall: "onChange",
                                    formatConfig: {
                                        title: "name",
                                        key: "value",
                                        value: "lable",
                                        children: "child",
                                    },
                                    "request": {
                                        "url": "/cm-sites-sys/dept/getTree?id=0",
                                        "method": "get",
                                    },
                                    maxTagCount: 1
                                }
                            },
                            "placeholder": "请选择所属部门",
                            "disabled": false,
                            "id": "sta_dept",
                            "size": "default",
                            "labelCode": "deptId",
                            "labelName": "请选择所属部门",
                            "defaultValue": "0",
                            "regStr": "",
                            "regMsg": ""
                        },
                        {
                            "component": {
                                "name": "sta_Date",
                                "config": {
                                    selectDateConfig: {
                                        defaultKey: "null",
                                        // selectConfig: ["today", "yesterday", "thisWeek", "lastWeek", "thisMonth", "lastMonth"]
                                    },
                                    onChangeCallFun: "onSearch",
                                    style: {
                                        width: 300
                                    }
                                }
                            },
                            "value:": "this.state.params.name",
                            "placeholder":  ["计分开始时间", "计分结束时间"],
                            "disabled": false,
                            "id": "sta_name",

                            "size": "default",
                            "labelCode": ["startTime", "endTime"],
                            'sameDay':true,
                            "defaultValue": [null, null],
                            "labelName": "",
                            "regStr": "",
                            "regMsg": ""
                        },

                        {
                            "style": {
                                "float": "left"
                            },
                            "component": {
                                "name": "sta_Button",
                                "config": {
                                    btnName: "查询",
                                    type: "primary",
                                    clickCall: "onSearch",
                                    style: {
                                        width: 64
                                    }
                                }
                            },
                            "disabled": false,
                            "id": "sta_searchBtn",
                            "size": "default",
                            "labelCode": "",
                        },
                        {
                            "style": {
                                "float": "left"
                            },
                            "component": {
                                "name": "sta_Button",
                                "config": {
                                    btnName: "重置",
                                    type: "default",
                                    clickCall: "onReset",
                                    // noRestKey: ["startTime", "endTime"],
                                    style: {
                                        width: 64
                                    }
                                }
                            },
                            "disabled": false,
                            "id": "sta_searchBtn",
                            "size": "default",
                            "labelCode": "",
                        },
                    ],
                    [
                        {
                            "style": {
                                "float": "left"
                            },
                            "component": {
                                "name": "sta_Button",
                                "config": {
                                    btnName: "导出",
                                    type: "default",
                                    clickCall: "onExport",
                                    "request": {
                                        "url": "/cm-sites-mmp/integral/integralLogExport?",
                                        "method": "downloadGet",
                                        "params": {
                                            busName: "busTopicSelection",
                                            pageSize: 9999
                                        },
                                    },
                                    style: {
                                        width: 64
                                    }
                                }
                            },
                            "disabled": false,
                            "id": "sta_searchBtn",
                            "size": "default",
                            "labelCode": "",
                        },
                    ]
                ]
            },
            "renderTable": {
                "defaultItemWidth": 200,
                "columns": [
                    {
                        "title": '序号',
                        "width": 50,
                        "dataIndex": 'index',
                        "key": 'index',
                    },
                    {
                        "title": '昵称',
                        "width": 110,
                        ellipsis: true,
                        "dataIndex": 'nickName',
                        "key": 'nickName',
                    },
                    {
                        "title": '手机号',
                        "width": 100,
                        "dataIndex": 'account',
                        "key": 'account',
                        ellipsis: true,
                    },
                    {
                        "title": '所属单位',
                        "width": 250,
                        "dataIndex": 'deptNames',
                        "key": 'deptNames',
                        ellipsis: true,
                        render: (record) => {
                            let deptNames = Array.isArray(record) ? record : [];
                            return deptNames.join('/')
                        }
                    },
                    {
                        "title": '注册时间',
                        "width": 120,
                        "dataIndex": 'createTime',
                        "key": 'createTime',
                        ellipsis: true,
                        render: (record) => {
                            return record?formatTime(record):''
                        }
                    },
                    {
                        title: '历史积分',
                        dataIndex: 'integralHistoryCount',
                        ellipsis: true,
                        sorter: true,
                        "width": 100,
                    },
                    {
                        title: '现有积分',
                        dataIndex: 'integralCount',
                        ellipsis: true,
                        sorter: true,
                        "width": 100,
                    },
                    {
                        title: '周期获得',
                        dataIndex: 'integralCountTime',
                        ellipsis: true,
                        sorter: true,
                        "width": 100,
                    },
                ]
            },
            "renderPage": {
                size: "middle",
                pageSizeOptions: ['10', '20', '30', '40']
            }
        },
    ]
};
